<template>
  <div id="app">
    <flash-light />

    <hero-area/>

    <projects-area/>

    <team-area />

    <contact-area/>
  </div>
</template>

<script>

  //import HeroArea from './components/HeroArea'
  import ProjectsArea from './components/ProjectsArea'
  import ContactArea from './components/ContactArea'
  import TeamArea from './components/TeamArea'

  import FlashLight from './components/flashlight-filter'

  import $ from 'jquery'

  export default {
    name: 'App',
    components: {
      //HeroArea,
      ProjectsArea,
      ContactArea,
      TeamArea,
      FlashLight
    },
    mounted () {
      $(document).ready(() => {
        document.querySelectorAll('.link-to-anchor[href^="#"]').forEach(anchor => {
          anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
            });
          });
        });
      })
    }
  }
</script>

<style lang="scss">
  @import "font-config";
  @import "styles/custom";
  @import "~bootstrap/scss/bootstrap";

  * {
    box-sizing: border-box;
    font-family: $font;
    word-spacing: 0.25rem;
  }

  a{
    color: $yellow;

    &:hover {
      color: darken($yellow, 20%);
    }
  }

  .text-yellow {
    color: $yellow
  }

</style>



// WEBPACK FOOTER //
// src/App.vue